import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import {
  ApplicationConfig,
  inject,
  provideAppInitializer,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideNativeDateAdapter } from '@angular/material/core';
import { AuthService } from '@core/services/auth.service';
import { PermissionService } from '@core/services/permission.service';
import { authInitializer, permissionsInitializer } from '@core/utils/auth.initializer.util';
import { provideCore } from 'app/core/core.providers';
import { provideCharts, withDefaultRegisterables } from 'ng2-charts';
import { AppRouteProviders } from './app.routes';

export const appConfig: ApplicationConfig = {
  providers: [
    provideHttpClient(withInterceptorsFromDi()),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideNativeDateAdapter(),
    AppRouteProviders,
    provideCore(),
    AuthService,
    PermissionService,
    provideAppInitializer(() => authInitializer(inject(AuthService))),
    provideAppInitializer(() =>
      permissionsInitializer(inject(PermissionService), inject(AuthService)),
    ),
    provideCharts(withDefaultRegisterables()),
  ],
};
